var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"duplicate":_vm.duplicate}),_vm._v(" "),_c('duplicate-event-modal',{attrs:{"number-of-used-events":_vm.numberOfUsedEvents,"original-event":_vm.event},model:{value:(_vm.isDuplicateEventModalVisible),callback:function ($$v) {_vm.isDuplicateEventModalVisible=$$v},expression:"isDuplicateEventModalVisible"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }